import { gql } from 'graphql-request'

export const QueryBlockBenefitsListing = gql`
  fragment FragmentBlockBenefitsListing on BlockBenefitsListingModelRecord {
    __typename
    id
    theme
    benefits {
      id
      number
      unit
      title
      description {
        value
      }
    }
  }
`

export const BlockBenefitsListing = {
  __typename: 'BlockBenefitsListing',
  fragmentName: 'FragmentBlockBenefitsListing',
  fragmentQuery: QueryBlockBenefitsListing,
  fragments: []
}
